/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RelocalizationStrategy {
}

export enum RelocalizationStrategy_Enum {
  NONE = 0,
  HEIGHT_OFFSET = 2,
  CYLINDER = 3,
  TRANSMISSION = 4,
  TSDF = 5,
  LOWEST_ORBIT = 6,
  UNRECOGNIZED = -1,
}

export function relocalizationStrategy_EnumFromJSON(object: any): RelocalizationStrategy_Enum {
  switch (object) {
    case 0:
    case "NONE":
      return RelocalizationStrategy_Enum.NONE;
    case 2:
    case "HEIGHT_OFFSET":
      return RelocalizationStrategy_Enum.HEIGHT_OFFSET;
    case 3:
    case "CYLINDER":
      return RelocalizationStrategy_Enum.CYLINDER;
    case 4:
    case "TRANSMISSION":
      return RelocalizationStrategy_Enum.TRANSMISSION;
    case 5:
    case "TSDF":
      return RelocalizationStrategy_Enum.TSDF;
    case 6:
    case "LOWEST_ORBIT":
      return RelocalizationStrategy_Enum.LOWEST_ORBIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RelocalizationStrategy_Enum.UNRECOGNIZED;
  }
}

export function relocalizationStrategy_EnumToJSON(object: RelocalizationStrategy_Enum): string {
  switch (object) {
    case RelocalizationStrategy_Enum.NONE:
      return "NONE";
    case RelocalizationStrategy_Enum.HEIGHT_OFFSET:
      return "HEIGHT_OFFSET";
    case RelocalizationStrategy_Enum.CYLINDER:
      return "CYLINDER";
    case RelocalizationStrategy_Enum.TRANSMISSION:
      return "TRANSMISSION";
    case RelocalizationStrategy_Enum.TSDF:
      return "TSDF";
    case RelocalizationStrategy_Enum.LOWEST_ORBIT:
      return "LOWEST_ORBIT";
    case RelocalizationStrategy_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRelocalizationStrategy(): RelocalizationStrategy {
  return {};
}

export const RelocalizationStrategy = {
  encode(_: RelocalizationStrategy, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RelocalizationStrategy {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRelocalizationStrategy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RelocalizationStrategy {
    return {};
  },

  toJSON(_: RelocalizationStrategy): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RelocalizationStrategy>, I>>(base?: I): RelocalizationStrategy {
    return RelocalizationStrategy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RelocalizationStrategy>, I>>(_: I): RelocalizationStrategy {
    const message = createBaseRelocalizationStrategy();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
